<template>
  <div>
    <Loading v-if="loading" />

    <v-container v-else class="py-10">
      <Title>{{ item.title }}</Title>

      <v-row>
        <v-col cols="12" md="5" v-if="item.text">
          <div
            class="text-body-2 font-weight-regular mt-8"
            v-html="item.text"
          ></div>
        </v-col>

        <v-col cols="12" :md="item.text ? 7 : 12">
          <div class="mt-6">
            <v-expansion-panels accordion hover flat class="items">
              <v-expansion-panel
                v-for="({ title, text }, keyItems) in items"
                :key="keyItems"
              >
                <v-expansion-panel-header>
                  <div class="text-body-1 font-weight-medium" v-if="title">
                    {{ title }}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div v-html="text"></div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Loading from "../../widgets/Loading.vue";
import Title from "../../widgets/Title.vue";

const _config = {
  item: {
    mod: "hospitalization-guide",
  },
  items: {
    mod: "hospitalization-guide-topics",
  },
};

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    item() {
      return this.$rest(_config.item.mod).item;
    },
    items() {
      return this.$rest(_config.items.mod).list;
    },
  },
  mounted() {
    this.$rest(_config.item.mod).get({
      save: (state, data) => (state.item = data),
    });

    this.$rest(_config.items.mod)
      .get()
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    Title,
  },
};
</script>

<style lang="scss">
.items {
  &.v-expansion-panels {
    .v-expansion-panel-header {
      .v-expansion-panel-header__icon {
        .v-icon {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
